import { Flow } from 'signup-constants/Flow';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { getFlowKey } from '../routing/getFlowKey';
import { getApplicationDomain } from '../constants/apiEnvironments';
import { getHubSpotForStartupsRedirect } from './getHSFXFallbackRedirectUrl';
import { hubSpotConnectRedirect } from './productLinks';
const getFlowToFallbackUrl = new Map([[Flow.Academy, (portalId, hublet = HubletOption.na1) => `${getApplicationDomain(hublet)}/academy/${portalId}`], [Flow.HubspotForStartups, (portalId, hublet = HubletOption.na1) => getHubSpotForStartupsRedirect({
  portalId,
  hublet
})], [Flow.Connect, (portalId, hublet = HubletOption.na1, isNewUser) => hubSpotConnectRedirect({
  portalId,
  hublet,
  isNewUser
})]]);
export const getFallbackOnboardingUrl = (portalId, hublet = HubletOption.na1, isNewUser) => {
  const flowKey = getFlowKey();
  const fallback = getFlowToFallbackUrl.get(flowKey);

  if (fallback) {
    return fallback(portalId, hublet, isNewUser);
  }

  return `${getApplicationDomain(hublet)}/getting-started/${portalId}`;
};